export enum LinkTypes {
  tel= 'tel',
  href= 'href',
}
